import { styled } from '../jss-style';
import rateStyle from './rate';

const useRateStyle = styled(rateStyle, 'rate');
export { rateStyle, useRateStyle };
export default useRateStyle;
